import * as React from "react";
import { observer } from "mobx-react-lite";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { DateTime } from "luxon";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { useHistory } from "react-router-dom";
import Edit from "@material-ui/icons/Edit";
import { UserRoleRuEnum, UserRoleEnum } from "../../../../static/enums/UserRole";
import { User } from "../../../../api/typings/Users";
import { Profiles, AdminProfile } from "../../../../api/typings/Profiles";
import { tableStore } from "../../../../mobx/stores/TableStore/TableStore";
import { Routes } from "../../../../routes/routes";

function adminsFilter(profile: Profiles): profile is AdminProfile {
  return profile.role === UserRoleEnum.admin;
}

interface AdminsProfilesTableRowProps {
  user: User;
}

export const AdminsProfilesTableRow = observer(({ user }: AdminsProfilesTableRowProps) => {
  const { usersProfiles, usersProfilesAdmins } = tableStore;
  const profilesAdmins = (Object.values(usersProfiles) as Profiles[]).filter(adminsFilter);
  const profilesId = user.profiles.map((profile) => profile.id);
  const profileInfo = profilesAdmins.find((profile) => profilesId.some((id) => profile.id === id));
  if (!profileInfo) return null;
  const adminInfo = usersProfilesAdmins[profileInfo.admin.id];
  const history = useHistory();

  return (
    <TableRow hover>
      <TableCell>{user.id}</TableCell>
      <TableCell>
        {user.firstname} {user.lastname}
      </TableCell>
      <TableCell>{UserRoleRuEnum[profileInfo.role]}</TableCell>
      <TableCell>{DateTime.fromISO(profileInfo.created_at).toFormat("dd.MM.yyyy HH:mm")}</TableCell>
      <TableCell>{DateTime.fromISO(profileInfo.updated_at).toFormat("dd.MM.yyyy HH:mm")}</TableCell>
      <TableCell align={"center"}>
        {adminInfo.is_super ? <Check color={"primary"} /> : <Close color={"secondary"} />}
      </TableCell>
      <TableCell>
        <Tooltip title={<Typography variant={"caption"}>Редактировать</Typography>}>
          <IconButton onClick={() => handleUserInfo(user.id)}>
            <Edit color={"secondary"} fontSize={"small"} />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );

  function handleUserInfo(id: string): void {
    history.push(`/${Routes.user}/${id}`);
  }
});
